import { Box, Modal, TextField, Typography, Button } from "@mui/material";
import { useState } from "react";
import SubmitButton from "../SubmitButton";
import { colors } from "../../common/colors";

type Props = {
  open: boolean;
  onClose: () => void;
  message: string;
  oldDescriptions?:any;
  onContinue: (text: string) => Promise<boolean>;
  lable?: string;
};

const styles = {
  container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "85%",
    maxWidth: 300,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 2,
    transition: "opacity 0.3s ease-in-out",
  },
  message: {
    textAlign: "center",
    padding: "20px",
  },
  buttons: {
    display: "flex",
    justifyContent: "space-between",
  },
  button: {
    cursor: "pointer",
    width: "50%",
    textAlign: "center",
    border: "0.5px solid gray",
    padding: "10px",
  },
  buttonLeft: {
    borderRight: "none",
  },
  buttonRight: {
    borderLeft: "none",
  },
};

const UpdateInput = (props: Props) => {
  const [text, setText] = useState<any>(props.oldDescriptions);
  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Box sx={styles.container}>
        <Typography variant="body1" sx={styles.message}>
          {props.message}
        </Typography>
        <Box sx={{ display: "flex", margin: "10px" }}>
          <TextField value={text} onChange={(e) => setText(e.target.value)} sx={{ width: "100%" }} id="outlined-basic" label={props.lable} variant="outlined" />
        </Box>
        <Box sx={styles.buttons}>
          <Button
            sx={{ ...styles.button, color: colors.farm_black }}
            onClick={() => {
              props?.onClose();
              setText("");
            }}
          >
            キャンセル
          </Button>
          <SubmitButton
            sx={{ ...styles.button, ...styles.buttonLeft, color: colors.farm_black }}
            validate={async () => true}
            onSubmit={() => props.onContinue(text)}
          >
            更新する
          </SubmitButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default UpdateInput;
